var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "416px",
    height: "325px",
    viewBox: "0 0 416 325",
    enableBackground: "new 0 0 416 325",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M293.144,178.965c-2.755,0-4.513,0-6.271,0 c-66.306,0-132.613-0.016-198.92,0.023c-6.956,0.004-12.437-2.563-15.551-8.85c-2.887-5.826-2.347-11.672,1.652-16.928 c3.622-4.76,8.645-6.288,14.494-6.279c44.648,0.068,89.297,0.037,133.945,0.037c23.14,0,46.278,0,70.658,0 c-1.861-1.952-3.015-3.211-4.22-4.418c-17.666-17.676-35.39-35.295-52.983-53.042c-7.858-7.927-6.733-19.787,2.156-25.364 c6.174-3.874,14.147-3.292,19.338,1.879c28.802,28.685,57.565,57.412,86.227,86.237c6.252,6.288,5.802,15.66-0.846,22.378 c-14.295,14.449-28.716,28.772-43.088,43.145c-13.901,13.9-27.75,27.854-41.734,41.67c-5.443,5.38-12.913,6.249-19.304,2.694 c-5.899-3.28-9.301-10.086-7.566-16.989c0.803-3.188,2.79-6.455,5.118-8.824c17.4-17.7,35.025-35.183,52.569-52.744 C290.059,182.349,291.219,181.03,293.144,178.965z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.3d98d82200caef87f8bd09b27c2fccb5.svg";
export { ForwardRef as ReactComponent };